import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import {
    StockOverrideReason,
    StockStatus,
    IVariantInventory,
    Inventory,
} from "../../utils/api";
import { useAuth } from "../useAuth";

export interface ISetStatusOverrideValues {
    status: StockStatus;
    expiresAt: string | null;
    reason: StockOverrideReason;
    note: string;
}

export const useSetStatusOverride = (
    variantId: string,
): UseMutationResult<IVariantInventory, unknown, ISetStatusOverrideValues> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IVariantInventory, unknown, ISetStatusOverrideValues>({
        mutationFn: async (values: ISetStatusOverrideValues) => {
            if (!token) {
                throw new Error(
                    "Cannot override the stock status without authorization token.",
                );
            }

            return await Inventory.setStatusOverride({
                variantId,
                ...values,
                token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["inventory", variantId]);
        },
    });
};
